class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = Math.max(Number(this.dataset.delay) * 1000 || 10000, 10000);
    this.form = this.querySelector('.js-form');
    this.ageVerificationPopup = document.querySelector('age-verification-popup');
    this.form?.addEventListener('submit', this.onSubscribe.bind(this));
  }

  hasBeenSeen() {
    try {
      if (localStorage.getItem('snob-newsletter-seen') === 'true') return true;
    } catch (error) {}
    return getCookie('newsletter-seen') !== null || getCookie('newsletter-closed') !== null || getCookie('newsletter-subscribed') !== null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') this.show();
      return;
    }
    if (this.hasBeenSeen()) return;
    const schedule = () => {
      const ready = () => {
        if (this.hasBeenSeen()) return;
        this.timer = setTimeout(() => {
          if (this.hasBeenSeen()) return;
          if (this.classList.contains('newsletter-popup-is-hidden') || document.querySelector('age-verification-popup[open]')) return;
          this.show();
        }, this.delay);
      };
      if ('requestIdleCallback' in window) requestIdleCallback(ready, { timeout: 2000 });
      else ready();
    };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  show(opener) {
    if (!Shopify.designMode) {
      if (this.hasBeenSeen()) return;
      try { localStorage.setItem('snob-newsletter-seen', 'true'); } catch (error) {}
      setCookie('newsletter-seen', 'true', 365);
    }
    super.show(opener);
  }

  hide() {
    super.hide();
    clearTimeout(this.timer);
    if (!Shopify.designMode) setCookie('newsletter-closed', 'true', 365);
  }

  onSubscribe() {
    setCookie('newsletter-subscribed', 'true', 365);
    this.hide();
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
